import { registerLocaleData } from "@angular/common";
import localePt from '@angular/common/locales/pt';
import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, LOCALE_ID } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideNgxMuvstok, KEYCLOAK_CONFIG, provideNgxMuvstokKeycloak } from "@muvstok/ngx-muvstok";
import { NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { provideToastr } from "ngx-toastr";
import { InitLoadService } from "./core/services/init-load.service";
import { routes } from "./app.routes";
import { MuvNgbDateDateFormatter } from "./utility/date-format";
import { requestInterceptor } from "./core/auth/interceptors/request-interceptor";
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from "@angular/common/http";

registerLocaleData(localePt, 'pt-BR');

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([requestInterceptor]), withInterceptorsFromDi()),
    provideNgxMuvstok(),
    { provide: NgbDateParserFormatter, useClass: MuvNgbDateDateFormatter },
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR',
    },
    {
      provide: KEYCLOAK_CONFIG,
      useClass: InitLoadService,
    },
    provideNgxMuvstokKeycloak(),
    provideToastr(),
  ],
};
